import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=1f61c246"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=1f61c246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonRichText: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/RichText.vue').default,StoryblokButton: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/storyblok/Button.vue').default})
